module.exports = __webpack_public_path__ + "assets/hat-e52b3e252a1ccc392163019a60bfe6f9.svg";